<script setup lang="ts">
import type { BaseIconName } from '@/js/account/components/base/BaseIcon.vue';
import BaseIcon from '@/js/account/components/base/BaseIcon.vue';
import { classNames } from '@/js/lib/bem';

defineProps<{
  icon: BaseIconName
  title: string
  value: string | number
  label?: string
}>();

const cn = classNames('dashboard-stat-card');
</script>

<template>
  <div :class="cn()">
    <h3 :class="cn('title')">
      <BaseIcon :name="icon" :class="cn('icon')" :width="16" :height="16" />
      {{ title }}
    </h3>
    <p :class="cn('value')">
      <span :class="cn('value-number')">{{ value }}</span>
      <span v-if="label" :class="cn('value-label')">{{ label }}</span>
    </p>
  </div>
</template>

<style lang="scss" scoped>
.dashboard-stat-card {
  display: flex;
  flex-direction: column;
  gap: 40px;
  background-color: var(--color-white);
  padding: 24px;
  border-radius: 4px;

  &__title {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.2;
    color: var(--color-text-secondary);
    margin: 0;
  }

  &__icon {
    color: var(--color-text-secondary);
    flex-shrink: 0;
  }

  &__value {
    display: flex;
    align-items: flex-end;
    gap: 16px;
    margin: 0;
  }

  &__value-number {
    font-size: 40px;
    font-weight: 400;
    line-height: 0.8;
    color: var(--color-text-primary);
    font-family: var(--font-family-serif);
  }

  &__value-label {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.2;
    color: var(--color-text-secondary);
  }

  @media (max-width: 768px) {
    padding: 16px;

    &__value {
      flex-direction: column;
      align-items: flex-start;
    }
  }
}
</style>
